module.exports = __webpack_public_path__ + "static/media/induscreed.885c9997.png";